export default __webpack_public_path__ + "d95fea84d54906dc20172c78069949fa.png";